// extracted by css-extract-rspack-plugin
export default {"removed":"EventValue-module__removed--CFMCl","added":"EventValue-module__added--JWhXl","old":"EventValue-module__old--YfOK8"};